export default defineNuxtPlugin(async (nuxtApp) => {
  const { createVfm } = await import("vue-final-modal");
  const vfm = createVfm() as any;
  nuxtApp.vueApp.use(vfm);
});
